export default "__VITE_ASSET__b98bf7f5__"